import { EmployeeComposed, EmployeeRole } from '@/api/apis/resources';
import { OrganType } from '@/api/apis/case';
import { roleNames } from '@/constants/user.constants';
import { RoleChip } from './RoleChip';

const organPropertyByRole: Partial<Record<EmployeeRole, keyof EmployeeComposed>> = {
  [EmployeeRole.ClinicalSpecialist]: 'organSpecializations',
  [EmployeeRole.RetrievalSurgeon]: 'organSpecializations',
  [EmployeeRole.ContractorRetrievalSurgeon]: 'organSpecializations',
  [EmployeeRole.OrganManagement]: 'organSpecializations',
  [EmployeeRole.OrganLeadership]: 'organSpecializations',
  [EmployeeRole.ClinicalAuditor]: 'organSpecializations',
  [EmployeeRole.ClinicalLead]: 'phoneSupportOrganSpecializations',
  [EmployeeRole.OrganManagementSpecialist]: 'organManagementSpecialistSpecializations',
  [EmployeeRole.ScheduleManagerRs]: 'rsScheduleManagerOrgans',
};

type UserRoleChipProps = {
  role: EmployeeRole;
  user: EmployeeComposed;
};

export const UserRoleChip = ({ role, user }: UserRoleChipProps) => {
  const organProperty = organPropertyByRole[role];
  const value = organProperty ? user[organProperty] : undefined;
  const organs = Array.isArray(value) ? (value as OrganType[]) : [];
  const roleName = roleNames[role] || '';

  if (!roleName) return null;

  return <RoleChip label={roleName} organs={organs} organBadgeProps={{ bgTone: 'bg60' }} />;
};
